export interface INewbuildingBookingState {
  isConfirmOpen: boolean;
  isEnabled: boolean;
  landingUrl: string;
  profitbaseUrl: string;
  status: EBookingStatus;
}

export enum EBookingStatus {
  Failure = 'failure',
  Initial = 'initial',
  Loading = 'loading',
  Success = 'success',
}

export interface IBookingDetail {
  label: string;
  text: string;
}
